<script setup lang="ts">
import { computed } from 'vue'
import Icon from './Icon.vue'

const props = defineProps({
  notification: {
    type: Object,
    default: () => ({
      type: 'success',
      notification: 'Pilot is eating in the cabin',
      id: 0,
    }),
  },
})

const emit = defineEmits(['remove'])

const status = computed(() => {
  return props.notification.type === 'error'
    ? 'x_circle'
    : props.notification.type === 'warning'
      ? 'caution_circle'
      : 'check_circle'
})

const color = computed(() => {
  return props.notification.type === 'error'
    ? 'DB3126'
    : props.notification.type === 'warning'
      ? 'f4c10980'
      : '049D2F'
})
</script>

<template>
  <div class="alert-panel justify-between">
    <div class="alert_panel_icon status">
      <icon :name="status" :color="`#${color}`" :size="16" />
    </div>
    <div class="w-75 txt-message">
      <p class="text-light fs-14 mb-0">{{ notification.notification }}</p>
    </div>
    <div @click="$emit('remove', notification.id)" class="alert_panel_icon close">
      <icon :name="'x'" :color="'#E4E4E4'" :size="20" />
    </div>
  </div>
</template>

<style scoped>
.alert-panel {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  align-self: center;
  background: var(--idi-shade0-85);
  border-radius: 8px;
  margin-top: 0.25em;
  width: 28em;
  position: relative;
}

.alert_panel_icon {
  padding-right: 12px;
  padding-left: 12px;
}

.close {
  position: relative;
  top: 0.2em;
}

.status {
  margin-top: -5px;
}

.txt-message {
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
